export enum ImportedForecastStatusEnum {
    FAILED = "FAILED",
    PROCESSED = "PROCESSED"
}